import firebase from "firebase";
import { setUid, reset, setAccessToken, setSpinner } from "../../../store/Store";

const authListener = (setAuthReady) => {
  firebase.auth().onIdTokenChanged(async (user) => {
    if (user) {
      let result = await user.getIdTokenResult(true);
      setAccessToken(result.token);
      setUid(user.uid);
      setSpinner(false);
    } else {
      reset();
    }
    setAuthReady(true);
  });
};

export default authListener;
